<template>
  <div class="d-block d-md-none">{{ column }}</div>
  <BadgeComponent :icon="item.icon" :className="item.className" :text="item.text" />
  <div v-if="item.baseline" :class="'mt-2 text-' + item.className">{{ item.baseline }}</div>
</template>

<script>
import BadgeComponent from "@/components/utils/badge/BadgeComponent.vue";

export default {
  name: "StatusCellDataTableComponent",
  components: { BadgeComponent },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
